import { defineMessages } from "react-intl";

export const conditionRowMessages = defineMessages({
  net: { id: "b2bConditions.row.net", defaultMessage: "Net" },
  allProperties: { id: "b2bConditions.row.allProperties", defaultMessage: "All properties" },
  someProperties: {
    id: "b2bConditions.row.someProperties",
    defaultMessage: "{count, plural, one {# property} other {# properties}}",
  },
});
